import { render, staticRenderFns } from "./PhotoPreviewCanvas.vue?vue&type=template&id=a09218b8&"
import script from "./PhotoPreviewCanvas.vue?vue&type=script&lang=ts&"
export * from "./PhotoPreviewCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports